import ConnectedSound from 'sounds/connected.wav';
import DisconnectedSound from 'sounds/disconnected.wav';
import NotificationSound from 'sounds/notification.wav';

export default {
  connected: new Audio(ConnectedSound),
  disconnected: new Audio(DisconnectedSound),
  notification: new Audio(NotificationSound),
};
